module.exports = __webpack_public_path__ + "static/media/siddharth-guntur-trip-26.4ca6f194.png";